import { AccountMultipleRemoveIcon } from './AccountMultipleRemoveIcon';

/**
 * author: Michael Richins
 * id 998E10E4-B96A-4DB2-9793-3E1C31D42501
 * name account-multiple-remove
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-remove.svg
 * tags
 * - Account / User 
 */
export const PersonMultipleRemoveIcon = AccountMultipleRemoveIcon;
export default PersonMultipleRemoveIcon